import { IElement } from "core-integration/src/store/elements/types";
import { IFixture } from "core-integration/src/store/fixtures/types";
import { ITeamsById } from "core-integration/src/store/teams/types";

export const getSuffixFromId = (id: number, isHome: boolean) => {
  const neutralIds: number[] = [];
  return neutralIds.indexOf(id) > -1 ? "(N)" : isHome ? "(H)" : "(A)";
};

/**
 * Accessible fixture labels used in player cards and list view tables.
 * @param element - The player/element used to determine home/away context.
 * @param fixtures - Fixtures to label.
 * @param teamsById - Lookup table for team details by ID.
 * @returns Accessible labels in the format "{Opponent}, {Home|Away}".
 */
export const getAccessibleFixtureLabels = (
  element: IElement,
  fixtures: IFixture[],
  teamsById: ITeamsById,
): string[] => {
  return fixtures.map((fixture) => {
    const isHome = element.team === fixture.team_h;
    const location = isHome ? "Home" : "Away";
    const oppTeam = isHome
      ? teamsById[fixture.team_a]
      : teamsById[fixture.team_h];
    return `${oppTeam.name}, ${location}`;
  });
};
